export default __webpack_public_path__ + "static/media/harmo.79ad7fb6.svg";